<div class="actions">
  <div class="actions__start">
    <ut-community-like-action [likeable]="item"></ut-community-like-action>
    <ut-community-likers [likeable]="item" [user]="user" [showEmpty]="true"></ut-community-likers>
    @if (showCommentCount) {
      <span class="actions__comments">
        <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
        {{ commentCount }} {{ commentCount === 1 ? 'comment' : 'comments' }}
      </span>
    }
  </div>
  <span class="actions__end">
    <ut-share-menu [url]="shareUrl" [text]="item.title"></ut-share-menu>
    @if (item.current_user_permissions?.subscribe) {
      <ut-community-subscribe-action [item]="item"></ut-community-subscribe-action>
    }
    @if (item.current_user_permissions?.hide) {
      <ut-community-hide-action [item]="item" (stateChanged)="stateChanged.emit()"></ut-community-hide-action>
    }
    @if (canReport) {
      <ut-community-report-action [item]="item"></ut-community-report-action>
    }
    <ng-content select="[itemActionsEnd]"></ng-content>
  </span>
</div>
